import { sendRequest } from '../api/gas';
export default async ({ memberId, firstName, lastName }, logger) => {
    return sendRequest(`member${memberId}`, 'edit', { memberId, firstName, lastName }, logger);
};
